import { router } from '@inertiajs/react'
import { useEffect, useState } from 'react'
import { useI18n } from '../../../lib/useI18n'

// Persistent support-impersonation banner (ADR-0003, §6.1): who's viewing, why,
// a live countdown to auto-expiry, and a one-click Exit.
type Props = { operator_email: string; reason: string; expires_at: string }

function remaining(expiresAt: string): string {
  const ms = new Date(expiresAt).getTime() - Date.now()
  if (ms <= 0) return '0:00'
  const total = Math.floor(ms / 1000)
  const m = Math.floor(total / 60)
  const s = total % 60
  return `${m}:${s.toString().padStart(2, '0')}`
}

export default function ImpersonationBanner({ operator_email, reason, expires_at }: Props) {
  const { t } = useI18n()
  const [left, setLeft] = useState(() => remaining(expires_at))

  useEffect(() => {
    const id = setInterval(() => setLeft(remaining(expires_at)), 1000)
    return () => clearInterval(id)
  }, [expires_at])

  return (
    <div className="flex flex-wrap items-center justify-between gap-2 bg-accent px-4 py-2 text-sm text-accent-ink">
      <span>
        {t('portal.impersonation.prefix')} <strong>{operator_email}</strong> — {reason} ·{' '}
        {t('portal.impersonation.expires_in')}{' '}
        <span className="font-mono" data-testid="impersonation-countdown">
          {left}
        </span>
      </span>
      <button
        type="button"
        // The support view opens in its own tab, so exiting ends the session and
        // closes the tab. The DELETE redirects first, so if the browser refuses to
        // close (only script-opened tabs are closable) the user still lands somewhere
        // sane rather than on a now-ended impersonated view.
        onClick={() => router.delete('/impersonation', { onSuccess: () => window.close() })}
        className="rounded-[var(--radius)] border border-accent-ink px-3 py-1 font-semibold"
      >
        {t('portal.impersonation.exit')}
      </button>
    </div>
  )
}
